<h2 mat-dialog-title>Nueva variedad</h2>

<div mat-dialog-content>
  <div fxLayout="row wrap" fxLayoutGap="4px">
    <!-- ========== -->
    <div fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>Variedad</mat-label>
        <input
          matInput
          [formControl]="variety_form"
          [(ngModel)]="new_variety.variety_name"
          type="text"
          name="variety_name"
          required
        />
        <mat-error *ngIf="variety_form.invalid">{{
          getErrorMessage()
        }}</mat-error>
      </mat-form-field>
    </div>

    <!-- ========== -->
    <div fxFlex="49.5" *ngIf="speciesObs | async as species">
      <mat-form-field appearance="outline">
        <mat-label>Especie</mat-label>
        <mat-select [(ngModel)]="new_variety.species_id">
          <mat-option
            *ngFor="let option of species.data"
            [value]="option.species_id"
          >
            {{ option.species_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div fxFlex="100">
      <mat-form-field appearance="outline">
        <mat-label>Sinónimos</mat-label>
        <input
          matInput
          type="text"
          name="synonyms"
          [(ngModel)]="new_variety.synonyms"
        />
        <mat-hint style="padding-top: 1.5em"
          >Separe varios sinónimos con comas (,). Ejemplo: Calabaza,
          Calabacilla</mat-hint
        >
      </mat-form-field>
    </div>
  </div>

  <h4>Características morfológicas - Flor</h4>

  <div fxLayout="row wrap" fxLayoutGap="4px">
    <!-- ========== -->
    <div *ngIf="descriptor_17" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_17.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_17.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_17.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_19" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_19.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_19.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_19.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_20" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_20.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_20.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_20.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <h4>Características morfológicas - Tubérculo</h4>

  <div fxLayout="row wrap" fxLayoutGap="4px">
    <!-- ========== -->
    <div *ngIf="descriptor_31" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_31.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_31.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_31.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_32" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_32.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_32.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_32.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_33" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_33.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_33.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_33.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_34" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_34.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_34.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_34.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_36" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_36.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_39.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_36.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_37" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_37.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_37.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_37.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_38" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_38.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_38.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_38.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_39" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_39.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_39.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_39.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- ========== -->
    <div *ngIf="descriptor_40" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_40.descriptor_label }}</mat-label>
        <mat-select
          (selectionChange)="
            fnSelectDescriptor($event, descriptor_40.descriptor_id)
          "
        >
          <mat-option
            *ngFor="let option of descriptor_40.descriptor_categories"
            [value]="option"
          >
            {{ option.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <h4>Características agronómicas</h4>

  <div fxLayout="row wrap" fxLayoutGap="4px">
    <!-- ========== -->
    <div *ngIf="descriptor_44" fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>{{ descriptor_44.descriptor_label }}</mat-label>
        <input
          matInput
          type="number"
          name="tuber_yield_per_plant_form"
          [formControl]="tuber_yield_per_plant_form"
          (change)="fnSelectDescriptor($event, descriptor_44.descriptor_id)"
        />
        <mat-error *ngIf="tuber_yield_per_plant_form.invalid"
          >Invalid value</mat-error
        >
      </mat-form-field>
    </div>

    <!-- ========== -->
    <div fxFlex="100">
      <mat-form-field appearance="outline">
        <mat-label>Comentarios</mat-label>
        <textarea
          matInput
          name="comment"
          [(ngModel)]="new_variety.comment"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-flat-button color="primary" (click)="fnSave()">Guardar</button>
</mat-dialog-actions>

<!--  -->
<!-- ========== -->
<!-- <div fxFlex="49.5">
      <mat-form-field appearance="outline">
        <mat-label>Nombre común</mat-label>
        <input matInput type="text" name="common_name" />
      </mat-form-field>
    </div> -->
